import request from '@utils/request'

export function fetchStatistic(params) {
  return request({
    url: '/admin/statistic',
    method: 'get',
    params,
  })
}
